import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAgentStatus } from '@obvious.tech/constellation'

export const AgentStatus = defineEntity('AgentStatus', {
  endpoint: 'units/api/AgentStatus',
  schema: SNoop<IAgentStatus>(),
})
